import Component from '@glimmer/component'
import { service } from '@ember/service'
import type ExternalRosteringService from 'district-ui-client/services/external-rostering'
import InlineAlert, { InlineSubtitle, InlineTitle } from 'district-ui-client/components/inline-alert'
import { AlertType } from 'district-ui-client/components/inline-alert'
import t from 'ember-intl/helpers/t'

export class DisabledFeaturesAlert extends Component<unknown> {
  @service externalRostering!: ExternalRosteringService

  get show() {
    return this.externalRostering.isEnabled
  }

  <template>
    {{#if this.show}}
      <InlineAlert @type={{AlertType.Information}} data-test-integrations-disabled-features-alert>
        <InlineTitle>
          {{t "integrations.disabledFeaturesAlert.title"}}
        </InlineTitle>
        <InlineSubtitle>
          {{t "integrations.disabledFeaturesAlert.body" providerName=this.externalRostering.displayName}}
        </InlineSubtitle>
      </InlineAlert>
    {{/if}}
  </template>
}

export default DisabledFeaturesAlert
